// utils
import { mapErrorsToModel } from '@/utils/api';

export const getContacts = async () => {
  return await window.axios
    .get('/contacts', {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getContactsByStatus = async (status) => {
  return await window.axios
    .get(`/contacts?filter[status]=${status}`, {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const getContactByStatus = async (status) => {
  return await window.axios
    .get(`/contacts?filter[status]=${status}&page[limit]=1`, {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then((response) => {
      // Limit return always 1 element
      if (response.data.data.length === 0) return null;

      return response.data.data[0];
    });
};

export const getDefaultContact = async () => {
  return await window.axios
    .get(`/contacts/-default`, {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const storeContact = async (contact) => {
  const method = contact.id ? 'patch' : 'post';

  // Always store contact as status "CUSTOMER"
  if (!contact.attributes.status) contact.attributes.status = 'CUSTOMER';

  if (contact.id === '' || contact.id === null) {
    delete contact.id;
  }

  return await window.axios
    .request({
      url: '/contacts/' + (contact.id ?? ''),
      method,
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
      data: { data: contact },
    })
    .then((response) => {
      if (response.status === 200 || response.status === 201) {
        return response.data;
      }
    })
    .catch((error) => {
      // Wenn Unprocessable Entity
      if (error.response.status === 422) {
        return mapErrorsToModel(error.response.data.errors);
      }
      return error.response.data;
    });
};
